import React from 'react';
import { EditOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { UserAvatar } from '../users/UserAvatar';
import { FormattedMessage } from 'react-intl';

const AvatarWrapper = styled.div`
  position: relative;
  width: 96px;
  height: 96px;
  cursor: pointer;

  .edit-badge {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.6);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid white;
    transition: all 0.3s ease;
  }

  &:hover .edit-badge {
    background: rgba(0, 0, 0, 0.8);
    transform: scale(1.1);
  }

  .edit-text {
    text-align: center;
    margin-top: 0.5rem;
  }
`;

const EditableAvatar = (props) => {
  const { src, onClick, showText = false } = props;
  return (
    <AvatarWrapper onClick={onClick}>
      <UserAvatar size={96} src={src} />
      <div className='edit-badge'>
        <EditOutlined style={{ fontSize: 16 }} />
      </div>
      {showText && <div className='edit-text'> <FormattedMessage id="profile.edit-profile.click"/></div>}
    </AvatarWrapper>
  );
};

export default EditableAvatar;
